import { kintFunctions } from '~kint/firebase/functions';
import Reservation, { ReservationBase } from '~kint/models/Reservation';

export default async function callReservation(reservationKey: string) {
  const reservationBase = await kintFunctions.call<ReservationBase>('callReservation', {
    reservationKey,
  });
  const reservationBases = Array.isArray(reservationBase) ? reservationBase : [reservationBase];
  const filteredReservationBases = reservationBases.filter((reservationBase) => {
    const tourDate = new Date(reservationBase.date ?? '2000-01-01');
    return tourDate > new Date(Date.now() - 365 * 24 * 60 * 60 * 1000 + 1);
  });
  if (filteredReservationBases.length != 1) {
    return null;
  }
  return new Reservation(filteredReservationBases[0]);
}
